import React, { useState } from "react";
import { Radio } from "antd";

const MaterialLikeRadioGroup = ({ label, value, onChange, options }) => {
    const [focused, setFocused] = useState(false);

    return (
        <div
            className='mui-input-container'
            onFocus={() => setFocused(true)}
            onBlur={() => setFocused(false)}
        >
            <label className="mui-label-radio">{label}</label>
            <Radio.Group
                value={value}
                onChange={onChange}
                className="w-full flex gap-4 pt-5 pb-2 mui-radio"
            >
                {options.map((opt) => (
                    <Radio key={opt.value} value={opt.value}>
                        {opt.label}
                    </Radio>
                ))}
            </Radio.Group>
        </div>
    );
};

export default MaterialLikeRadioGroup;
